import { BaseProtoDto } from '../../../shared/modules/base/dtos/base-proto.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AreaTypeEnum } from '../../../shared/modules/settings/enums/area-type.enum';
import { ProtoCountryDto } from '../../countries/dtos/proto-country.dto';

/**
 * Area DTO
 */
export class ProtoAreaDto extends BaseProtoDto {
	/**
	 * Country ID this area belongs to
	 */
	countryId!: number;

	/**
	 * Country this area belongs to
	 */
	country!: ProtoCountryDto;

	/**
	 * Parent area ID if this area is a sub-area (e.g., a city within a state).
	 */
	parentId?: number;

	/**
	 * Parent area if this area is a sub-area (e.g., a city within a state).
	 */
	parent?: ProtoAreaDto;

	/**
	 * Area name
	 */
	name!: string;

	/**
	 * Area type
	 */
	type!: AreaTypeEnum;

	/**
	 * Flag indicating whether this area is in use
	 */
	isVisible!: boolean;

	/**
	 * External reference for the area
	 */
	externalReference?: string;

	/**
	 * Metadata associated with the area
	 */
	metadata?: Record<string, any>;

	/**
	 * Center of the area represented as a GeoJSON Point
	 */
	center!: string;

	/**
	 * Polygon of the area represented as a GeoJSON Polygon
	 */
	polygon!: string;

	/**
	 * Files associated with the area
	 */
	files?: FileDto[];
}
